import { useCallback } from 'react';

import { onAnalytics, ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics';

import { PlaybackState } from './playbackState';
import { BuildPlaybackEventFunction } from './buildPlaybackEvent';
import { getAdType } from '../../utils';
import { AdPlayerEventParams } from '../../types';

export const useTriggerOnAdSkipped = (buildPlaybackEvent: BuildPlaybackEventFunction) => {
    const triggerOnAdSkipped = useCallback(
        (playbackState: PlaybackState | undefined, params: AdPlayerEventParams) => {
            const event = buildPlaybackEvent('AD_SKIPPED', playbackState);
            if (!event) return;

            const assetDuration = (playbackState?.asset?.duration ?? 0) * 1000;
            onAnalytics(ANALYTICS_TRIGGERS.AD_SKIPPED, {
                ...event,
                adId: params.adId,
                adName: params.adName,
                adPosition: getAdType(params.adPosition, assetDuration),
                adPlaybackPosition: Math.round(playbackState?.currentTime ?? 0),
                adDuration: params.adDuration,
            });
        },
        []
    );

    return triggerOnAdSkipped;
};
